<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="flex items-center"
            v-if="!modeTemplate"
          >
            <input
              class='k-checkbox !mr-2 checkbox-lg'
              type='checkbox'
              v-model="checkall"
              @click="changeAllCheckbox(!checkall)"
            />
            <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.check_all_fields')}}</label>
          </div>

          <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('groups.data')}}</h3>
          <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.verTodoGroups"
                  />
                  <el-switch 
                    class="switch-text break-normal" 
                    v-model="form.verTodoGroups" 
                    :active-text="$t('configurations.ver_todo_groups')"/>
                  <base-tooltip-icon size="sm" :content="tooltipverTodoGroups" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.verTodoStatuses"
                  />
                  <el-switch 
                    class="switch-text break-normal" 
                    v-model="form.verTodoStatuses" 
                    :active-text="$t('configurations.ver_todo_statuses')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.verTodoCompanies"
                  />
                  <el-switch 
                    class="switch-text break-normal" 
                    v-model="form.verTodoCompanies" 
                    :active-text="$t('configurations.ver_todo_companies')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>

          <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('avisos.header')}}</h3>

              <div class="mt-2 mb-4">
                <div class="mandatory flex items-center mb-4">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EnviarAvisos"
                  />
                  <el-switch class="switch-text break-normal" v-model="form.EnviarAvisos" :active-text="$t('app.active')"></el-switch>
                </div>
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EnviarAvisosUsuarios"
                  />
                  <el-switch class="switch-text break-normal" v-model="form.EnviarAvisosUsuarios" :active-text="$t('configurations.send_alerts_users')"></el-switch>
                </div>
              </div>
              
              <div class="lg:mb-2">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoNuevaEmitida"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_nueva_emitida')}}
                      </label>
                        <el-switch 
                          v-if="!modeTemplate"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="valuesAdd.EmailAvisoNuevaEmitida" 
                          :inactive-text="$t('app.add')"
                          :active-text="$t('configurations.sustitute')" 
                          inactive-color="var(--primary-800)"
                          />
                    </div>
                    <el-form-item prop="EmailAvisoNuevaEmitida">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoNuevaEmitida"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              
              <div class="lg:mb-2">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoNuevaRecibida"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_nueva_recibida')}}
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoNuevaRecibida" 
                        :inactive-text="$t('app.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                      />
                    </div>
                    <el-form-item prop="EmailAvisoNuevaRecibida">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoNuevaRecibida"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="lg:mb-2">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoCambioEstado"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_cambio_estado')}}
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoCambioEstado" 
                        :inactive-text="$t('app.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                      />
                    </div>
                    <el-form-item prop="EmailAvisoCambioEstado">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoCambioEstado"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="lg:mb-2">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoVinculaciones"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_aviso_vincul')}}
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoVinculaciones" 
                        :inactive-text="$t('app.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                      />
                    </div>
                    <el-form-item prop="EmailAvisoVinculaciones">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoVinculaciones"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('app.edit_fields')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_entity', { entity })" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_entity', { entity })" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
          >
            <div v-html="$t('app.preselected_entities', { entity })" />
          </el-popover>
        </template>
      </base-footer>
      <link-groups-by-client-id-dialog
        ref="templatelinkgroupsdialog" 
        :title="titleLinkGroups" 
        :idCliente="id" 
        :modeTemplate="modeTemplate" 
        :dialogOpen="linkToGroupsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { getClient } from '@/services/clients/getClient'
import { getGroupTemplate } from '@/services/configurations/groups/template/getGroupTemplate'
import { updateGroupTemplate } from '@/services/configurations/groups/template/updateGroupTemplate'
import { applyGroupTemplate } from '@/services/configurations/groups/template/applyGroupTemplate'
import { applyGroupKeys } from '@/services/configurations/groups/template/applyGroupKeys'

import { i18n } from '@/i18n'

import { email as emailRegex } from '@/utils/regex'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import LinkGroupsByClientIdDialog from '@/components/LinkGroupsByClientIdDialog.vue'


function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}
export default {
  /* eslint-disable camelcase */
  name: 'group-template-detail',
  components: {
    DetailLayoutFullWidth,
    LinkGroupsByClientIdDialog,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      enableEditCampos: true,
      searchView: false,
      linkToGroupsDialog: false,
      activeName: 'es',
      entity: i18n.t('groups.header').toLowerCase(),
      header: {
        title: i18n.t('configurations.template_group_header_text'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations/groups'
      },
      tooltipverTodoGroups: i18n.t('tooltip.groups.ver_todo_groups'),
      tooltipVerTodoStatuses: i18n.t('tooltip.groups.ver_todo_statuses'),
      tooltipVerTodoCompanies: i18n.t('tooltip.groups.ver_todo_companies'),
      checkall: false,
      valuesCheckbox: {
        verTodoGroups: false,
        verTodoStatuses: false,
        verTodoCompanies: false,
        EnviarAvisos: false,
        EnviarAvisosUsuarios: false,
        EmailAvisoNuevaEmitida: false,
        EmailAvisoNuevaRecibida: false,
        EmailAvisoCambioEstado: false,
        EmailAvisoVinculaciones: false,
      },
      valuesAdd: {
        EmailAvisoNuevaEmitida: true,
        EmailAvisoNuevaRecibida: true,
        EmailAvisoCambioEstado: true,
        EmailAvisoVinculaciones: true,
      },
      form: {
        verTodoGroups: false,
        verTodoStatuses: false,
        verTodoCompanies: false,
        EnviarAvisos: false,
        EnviarAvisosUsuarios: false,
        EmailAvisoNuevaEmitida: null,
        EmailAvisoNuevaRecibida: null,
        EmailAvisoCambioEstado: null,
        EmailAvisoVinculaciones: null,
        IdCliente: null,
        IdPlantilla: 0
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        EmailAvisoNuevaEmitida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoNuevaRecibida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoCambioEstado: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoVinculaciones: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkGroups () {
      return this.modeTemplate ? i18n.t('configurations.link_template_to_entity', { entity: this.entity }) : i18n.t('configurations.apply_selected_to_entity', { entity: this.entity })
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = i18n.t('configurations.template_group_header_text_mode')
      else this.header.title = i18n.t('configurations.template_group_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: i18n.t('clients.header')
      })
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.Cliente.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.Cliente.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectGroups()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template.respuesta)
    }

    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations/groups'
  },
  methods: {
    preSelectGroups () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.groups) {
        setTimeout(() => {
          this.$refs.templatelinkgroupsdialog.changeSelectedGroups(data.groups)
        }, 500)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.verTodoGroups = value
      this.valuesCheckbox.verTodoStatuses = value
      this.valuesCheckbox.verTodoCompanies = value
      this.valuesCheckbox.EnviarAvisosUsuarios = value
      this.valuesCheckbox.EmailAvisoNuevaEmitida = value
      this.valuesCheckbox.EmailAvisoNuevaRecibida = value
      this.valuesCheckbox.EmailAvisoCambioEstado = value
      this.valuesCheckbox.EmailAvisoVinculaciones = value
      this.valuesCheckbox.EnviarAvisos = value
    },
    toggleDialogLink: function () {
      this.linkToGroupsDialog = !this.linkToGroupsDialog
    },
    applyLinkHandler: async function (groups) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateGroups('ruleForm', groups)
      } else {
        this.UpdateGroupsWithSelected('ruleForm', groups)
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', client))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler: function ({ send_alerts, AgruparEmailsAvisos }) {
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email_multiple')))
      } else {
        callback()
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            VerTodoGrupos: this.form.verTodoGroups,
            VerTodoEmpresas: this.form.verTodoCompanies,
            VerTodoEstados: this.form.verTodoStatuses,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EnviarAvisos: this.form.EnviarAvisos,
            IdCliente: this.form.IdCliente,
            IdPlantilla: this.form.IdPlantilla,
          }
          const response = await updateGroupTemplate({ idCliente: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_template_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateGroups: function (formName, groups) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            VerTodoGrupos: this.form.verTodoGroups,
            VerTodoEmpresas: this.form.verTodoCompanies,
            VerTodoEstados: this.form.verTodoStatuses,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EnviarAvisos: this.form.EnviarAvisos,
            IdCliente: this.form.IdCliente,
            IdPlantilla: this.form.IdPlantilla,
          }
          this.toggleDialogLink()
          const response = await updateGroupTemplate({ idCliente: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_template_msg'), 'success')
            const response = await applyGroupTemplate({ idCliente: this.id }, groups)
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.updated_groups_msg'), 'success')
            }
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateGroupsWithSelected: function (formName, groups) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idGrupos: groups,

            checkVerTodoGrupos: this.valuesCheckbox.verTodoGroups,
            checkVerTodoEmpresas: this.valuesCheckbox.verTodoCompanies,
            checkVerTodoEstados: this.valuesCheckbox.verTodoStatuses,
            checkEnviarAvisosUsuarios: this.valuesCheckbox.EnviarAvisosUsuarios,
            checkEmailAvisoNuevaEmitida: this.valuesCheckbox.EmailAvisoNuevaEmitida,
            checkEmailAvisoNuevaRecibida: this.valuesCheckbox.EmailAvisoNuevaRecibida,
            checkEmailAvisoCambioEstado: this.valuesCheckbox.EmailAvisoCambioEstado,
            checkEmailAvisoVinculaciones: this.valuesCheckbox.EmailAvisoVinculaciones,
            checkEnviarAvisos: this.valuesCheckbox.EnviarAvisos,

            addEmailAvisoNuevaEmitida: !this.valuesAdd.EmailAvisoNuevaEmitida,
            addEmailAvisoNuevaRecibida: !this.valuesAdd.EmailAvisoNuevaRecibida,
            addEmailAvisoCambioEstado: !this.valuesAdd.EmailAvisoCambioEstado,
            addEmailAvisoVinculaciones: !this.valuesAdd.EmailAvisoVinculaciones,
            
            VerTodoGrupos: this.form.verTodoGroups,
            VerTodoEmpresas: this.form.verTodoCompanies,
            VerTodoEstados: this.form.verTodoStatuses,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            IdCliente: this.form.IdCliente,
            IdPlantilla: this.form.IdPlantilla,
          }
          this.toggleDialogLink()
          const response = await applyGroupKeys({ idCliente: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.updated_groups_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
      else this.$router.push({ name: 'configurations/groups' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getGroupTemplate({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (template) {
      if (template) {
        this.form.verTodoGroups = template.VerTodoGrupos ? template.VerTodoGrupos : false
        this.form.verTodoCompanies = template.VerTodoEmpresas ? template.VerTodoEmpresas : false
        this.form.verTodoStatuses = template.VerTodoEstados ? template.VerTodoEstados : false

        this.form.EmailTecnico = template.EmailTecnico ? template.EmailTecnico : null
        this.form.EnviarAvisos = template.EnviarAvisos ? template.EnviarAvisos : null
        this.form.EnviarAvisosUsuarios = template.EnviarAvisosUsuarios ? template.EnviarAvisosUsuarios : null
        this.form.EmailAvisoNuevaEmitida = template.EmailAvisoNuevaEmitida ? template.EmailAvisoNuevaEmitida : null
        this.form.EmailAvisoNuevaRecibida = template.EmailAvisoNuevaRecibida ? template.EmailAvisoNuevaRecibida : null
        this.form.EmailAvisoCambioEstado = template.EmailAvisoCambioEstado ? template.EmailAvisoCambioEstado : null
        this.form.EmailAvisoVinculaciones = template.EmailAvisoVinculaciones ? template.EmailAvisoVinculaciones : null
        this.form.IdCliente = template.IdCliente ? template.IdCliente : null
        this.form.IdPlantilla = template.IdPlantilla ? template.IdPlantilla : null
      }
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
